export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_02.f82dc044.jpg";